// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* CONTENT */\n.main-content-normal {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: auto;\n  min-height: calc(100% - 100px);\n  margin-top: 60px;\n}\nfooter.footer {\n  position: relative;\n  float: left;\n  width: 100vw;\n  height: 40px;\n  background-color: var(--darkest-color);\n}\n", ""]);
// Exports
module.exports = exports;
